const ElectionPeriods = [
    'days',
    'weeks',
    'months',
    'years'
]

export default ElectionPeriods;
